// extracted by mini-css-extract-plugin
export default {"company__list":"Company_company__list__MH4t1","company__item":"Company_company__item__67uIS","company__link":"Company_company__link__6Z9Gr"};